import { render, staticRenderFns } from "./NeedsSummaryNotes.vue?vue&type=template&id=182bc3c2&scoped=true&"
import script from "./NeedsSummaryNotes.vue?vue&type=script&lang=js&"
export * from "./NeedsSummaryNotes.vue?vue&type=script&lang=js&"
import style0 from "./NeedsSummaryNotes.vue?vue&type=style&index=0&id=182bc3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182bc3c2",
  null
  
)

export default component.exports